export const API_URL = `https://forkify-api.herokuapp.com/api/v2/recipes`;
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = 'f4bfe8ac-064f-4a64-9ac2-01929109226d';
export const MODAL_CLOSE_SEC = 2500;